/* tslint:disable */
export class WebAnalyticsUTagData {
  page_name?: string;
  channel?: string;
  site_indicator?: string;
  login_status?: string;
  site_country?: string;
  site_language?: string;
  tealium_environment?: string;
  tealium_profile?: string;
  trueclient_ip?: string;
  time_stamp?: string;
  app_build_version?: string;
  app_region?: string;
  app_name?: string;
  loyalty_tier?: string;
  loyalty_id?: string;
  loyalty_balance?: string;
  partner_code_info?: string;
  gd_treatment_code?: string;
  error_id?: string;
  server?: string;
  pnr?: string;
}
/* tslint:enable */
